import { dataForUserChat, currentChatType } from "../../types/currentChatsTypes"

export const setCurrentChatData = (payload: dataForUserChat) => {
    return { type: currentChatType.SET_USER_CHAT, payload }
}

